// extracted by mini-css-extract-plugin
export var standaloneTable = "_fn-0";
export var standaloneTableWithBodyFill = "_fn-1";
export var withExtraHeader = "_fn-2";